import { BCancellationFeeTypeEnum } from '@/types/backend';
const useIsBankImprint = ({ isCallPrice, calculatedPrice, cancellation }) => {
    return !isCallPrice && (!calculatedPrice || calculatedPrice.total === 0) && !!cancellation?.fees && cancellation.fees.value > 0 && cancellation.fees.type === BCancellationFeeTypeEnum.Absolute;
};
export default useIsBankImprint;
